import { styled } from '@mui/material'
import Icon from '@mui/material/Icon'
import IconButton from '@mui/material/IconButton'
import React from 'react'

import { ChoiceValueSingle, LocalOnAnswerType } from '@/app/module/campaigns/types'

import ChoiceLabel from './question/choice/choice-label'
import SingleChoice from './question/choice/single-choice'

type Props = {
  choiceIndex: number
  id: string
  isCloseDisabled: boolean
  label?: string
  reply: string

  onChange: (value: LocalOnAnswerType, index: number) => void
  onRemove: (index: number) => void
}

const ResponseCatiMultiSelectItem: React.FC<Props> = ({
  choiceIndex,
  isCloseDisabled,
  label,
  reply,
  onChange,
  onRemove,
}) => {
  const handleChoiceChange = React.useCallback(
    (value: ChoiceValueSingle) => {
      onChange(
        {
          reply: value.reply,
          actions: [],
          label,
        },
        choiceIndex,
      )
    },
    [choiceIndex, label, onChange],
  )

  const handleLabelChange = React.useCallback(
    (newLabel: string) => {
      onChange(
        {
          reply,
          actions: [],
          label: newLabel,
        },
        choiceIndex,
      )
    },
    [choiceIndex, reply, onChange],
  )

  const handleRemove = React.useCallback(() => onRemove(choiceIndex), [choiceIndex, onRemove])

  return (
    <Container>
      <HeaderRow>
        <LabelCol>
          <ChoiceLabel label={label || ''} onChange={handleLabelChange} />
        </LabelCol>
        <IconButton
          className="campaign-question-onAnswer-choice-delete-btn"
          data-testid="campaign-question-answer-delete-btn"
          onClick={handleRemove}
          disabled={isCloseDisabled}
          size="small"
        >
          <Icon fontSize="small">close</Icon>
        </IconButton>
      </HeaderRow>
      <ContentRow>
        <InputCol>
          <SingleChoice tagList={{ reply }} onChange={handleChoiceChange} />
        </InputCol>
      </ContentRow>
    </Container>
  )
}

const Container = styled('div')({
  backgroundColor: 'rgb(245, 245, 245)',
  padding: '12px',
  margin: '12px 0',
})

const HeaderRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

const LabelCol = styled('div')({
  height: '32px',
})

const ContentRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '8px',
})

const InputCol = styled('div')({
  flex: 1,
})

export default React.memo(ResponseCatiMultiSelectItem)
